import { render, staticRenderFns } from "./IconSvgSDBPNewsFeed.vue?vue&type=template&id=417cffcd&scoped=true&"
import script from "./IconSvgSDBPNewsFeed.vue?vue&type=script&lang=js&"
export * from "./IconSvgSDBPNewsFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417cffcd",
  null
  
)

export default component.exports